export { reducer } from './data/reducer/reducer'
export {
  fetchCollectionsAndPlacesEpic,
  createCollectionEpic,
  editCollectionEpic,
  deleteCollectionEpic,
  savePlaceInCollectionEpic,
  deletePlaceFromCollectionEpic,
} from './data/epic/epic'

import Collections from './Collections'

export { ViewType } from './Collections'

export default Collections
